import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const ExcelToXliffArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="How to Convert Excel to XLIFF for Translation"
            subtitle="A comprehensive guide to preparing your Excel files for professional translation workflows."
        >
            <h3>Why Convert Excel to XLIFF?</h3>
            <p>
                Excel is a fantastic tool for data organization, but it's not designed for translation.
                Professional translators use Computer-Aided Translation (CAT) tools that thrive on XLIFF
                (XML Localization Interchange File Format). Converting your Excel files to XLIFF ensures:
            </p>
            <ul>
                <li><strong>Better Segmentation:</strong> Sentences are properly split, allowing for accurate translation memory matching.</li>
                <li><strong>Context Protection:</strong> Keys, IDs, and non-translatable columns are hidden from the translator, preventing accidental corruption.</li>
                <li><strong>Standardization:</strong> XLIFF is the industry standard, compatible with Trados, MemoQ, Phrase, and more.</li>
            </ul>

            <h3>The Challenge with Raw Excel</h3>
            <p>
                Sending a raw Excel file to a translator often leads to issues. They might translate the wrong columns,
                break formulas, or struggle with embedded HTML tags. Without proper segmentation, your Translation Memory (TM)
                becomes cluttered with paragraph-sized chunks instead of reusable sentences.
            </p>

            <h3>How Our Converter Helps</h3>
            <p>
                Our tool bridges the gap between Excel and CAT tools. It allows you to:
            </p>
            <ol>
                <li><strong>Select Columns:</strong> Clearly define which columns contain source text and where translations should go.</li>
                <li><strong>Protect Data:</strong> Keep your keys and metadata safe.</li>
                <li><strong>Handle HTML:</strong> Automatically parse and protect HTML tags within your Excel cells.</li>
            </ol>
        </ArticleLayout>
    );
};
